import React, { useState, useContext,useMemo } from 'react';
import { GlobalContext } from "../context/GlobalState";
import { v4 as uuid } from "uuid";
import { Link, useHistory } from "react-router-dom";
import { format } from 'date-fns'
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button, Navbar,
  Nav,
  NavItem,
  NavbarBrand,
  Container
} from "reactstrap";

import Select from 'react-select'
import countryList from 'react-select-country-list'
 import axios from 'axios';

export const AddUser = () => {
  const [OC, setoc] = useState('')
  const options = useMemo(() => countryList().getData(), [])

  const changeHandler = value => {
    setoc(value)
  }
  const changeHandler2 = value => {
    setdc(value)
  }
  const changeHandler3 = value => {
    setcl(value)
  }
  const [name, setName] = useState('');
  const [trackingNo, setTRN] = useState(Math.floor(1000000000 + Math.random() * 9000000000));
  const [sender, setsender] = useState("");
  const [receiver, setreceiver] = useState("");
  const [dsc, setdsc] = useState("");
  const [iv, setiv] = useState("");
  const [sc, setsc] = useState();
  const [cc, setcc] = useState();
  const [sts, setsts] = useState("ENROUTE");
  const [tc, settc] = useState();
  const [qty, setqty] = useState();
  const [org, setorg] = useState("");
  const [dst, setdst] = useState("");
  const [prg, setprg] = useState();
  const [cl, setcl] = useState();
  const [phone, setphone] = useState();
  const [email, setemail] = useState();
  const [sphone, setsphone] = useState();
  const [semail, setsemail] = useState();
  const[weight,setweight]=useState(0)
  const[pm,setpm]=useState("CASH")
  const[ct,setct]=useState("FEDEX")
  const[dc,setdc]=useState()
  const[dte,setdte]=useState()
  const[ddate,setddate]=useState()
  const[ins,setins]=useState()
  const[st,setst]=useState("AIR FREIGHT")
  const { addUser } = useContext(GlobalContext);
  const history = useHistory();

  const onSubmit = (e) => {
    e.preventDefault();

    const newpackage = {
      trackingNumber: trackingNo,
      
from:sender,
to:receiver,
description:dsc,
value:iv,
email:email,
shipmenttype:st,
phone:phone,senderemail:semail,
senderphone:sphone,
currentlocation:cl,
Shippingcost:sc,
status:sts,
clearancecost:cc,
totalcost:tc,
Quantity:qty,
product:"bag",
date:dte,
origin:org,
Destination:dst,
progress:prg,
weight:weight,
Paymentmode:pm,
courier:ct,
origincountry:OC,
destinationcountry:dc,
deliveryday:ddate,
insurance:ins
      
    }
    axios.post('https://princetrack-f6ffc-default-rtdb.europe-west1.firebasedatabase.app/pkg2.json', newpackage)
        .then(response => {alert("package added successfully")
        history.push("/admindash104");}
        )
        .catch(error => {
          alert("package failed to add")
         ;
         console.log("err;",error)
        });
   
  }

  const onChange = (e) => {
    setName(e.target.value);
  }
  

  return (
    <div style={{background:"teal"}}>
       <Navbar color="dark" dark >
      <Container>
        <NavbarBrand href="/">Swift way Cargo </NavbarBrand>
        <h3 style={{color:"white"}}>Add New Package</h3>
        <Nav>
          <NavItem>
            <Link className="btn btn-danger" to="/admindash104"> Back</Link>
          </NavItem>
        </Nav>

      </Container>
    </Navbar>
    <Form onSubmit={onSubmit} style={{ width:"100%",margin:"auto",}}
    
    
    >
      <div style={{display:"flex" ,gap:'10px',justifyContent:'space-evenly',width:"90vw",flexWrap:"wrap",}}>
        <FormGroup>
          <h1>PACKAGE INFORMATION</h1>
          <Label>Tracking No:</Label>
     <Input type="number" value={trackingNo} disabled onChange={(e)=>{
       setTRN(e.target.value)
     }} name="trackingNo" placeholder="Enter a unique 10 digit number" required></Input>
      <Label>description:</Label>
     <Input type="text" value={dsc} onChange={(e)=>{
       setdsc(e.target.value)
     }} name="dsc" placeholder="Enter description" required></Input>
     <Label>Weight:</Label>
     <Input type="number" value={weight} onChange={(e)=>{
       setweight(e.target.value)
     }} name="dsc" placeholder="Enter Weight in kg" required></Input>
     <Label>item value:</Label>
     <Input type="text" value={iv} onChange={(e)=>{
       setiv(e.target.value)
     }} name="sender" placeholder="Enter item value" required></Input>
     
     <Label>Shipping cost:</Label>
     <Input type="number" value={sc} onChange={(e)=>{
       setsc(e.target.value)
     }} name="sc" placeholder="Enter shipping cost" required></Input>
      <Label>Insurance cost:</Label>
     <Input type="number" value={ins} onChange={(e)=>{
       setins(e.target.value)
     }} name="sc" placeholder="Enter insurance cost" required></Input>
     <Label>Shipping date:</Label>
     <Input type="text" value={dte} onChange={(e)=>{
       setdte(e.target.value)
     }} name="sc" placeholder="Enter shipping date dd/mm/yyyy" required></Input>
     <Label>Expected delivery date:</Label>
     <Input type="text" value={ddate} onChange={(e)=>{
       setddate(e.target.value)
     }} name="sc" placeholder="Enter expected delivery date dd/mm/yyyy" required></Input>
      <Label>Payment Mode</Label>
     <br/>
     <select name="" onChange={(e)=>{setpm(e.target.value)}} required value={pm} id="">
       <option value="CASH">CASH</option>
       <option value="CHEQUE">CHEQUE</option>
       <option value="BACS">BACS</option>
       
     </select>
     <br/>
     <Label>Shipment Type</Label>
     <br/>
     <select name="" onChange={(e)=>{setst(e.target.value)}} required value={st} id="">
       <option value="AIR FREIGHT">AIR FREIGHT</option>
       <option value="INTERNATIONAL SHIPPING">INTERNATIONAL SHIPPING</option>
       <option value="TRUCKLOAD">TRUCKLOAD</option>
       <option value="VAN MOVE">VAN MOVE</option>
       
     </select>
     <br/>
      <Label>Courier Type:</Label>
     <br/>
     <select name="" onChange={(e)=>{setct(e.target.value)}} required value={ct} id="">
       <option value="FEDEX">FEDEX</option>
       <option value="USPS">USPS</option>
       <option value="DHL">DHL</option>
       
     </select>
     <br/>
     <Label>Status:</Label>
     <br/>
     <select name="" required onChange={(e)=>{setsts(e.target.value)}} value={sts} id="">
       <option value="ENROUTE">ENROUTE</option>
       <option value="PENDING">PENDING</option>
       <option value="ON HOLD">ON HOLD</option>
       <option value="RETURNED">RETURNED</option>
       <option value="OUT FOR DELIVERY">OUT FOR DELIVERY</option>
       <option value="PICKED UP">PICKED UP</option>
       <option value="DELIVERED">DELIVERED</option>
       <option value="IN TRANSIT">IN TRANSIT</option>
     </select>
     <br/>
     <Label>QTY:</Label>
     <Input type="text" value={qty} onChange={(e)=>{
       setqty(e.target.value)
     }} name="qty" placeholder="Enter Quantity" required></Input>
      <Label>progress:</Label>
     <Input type="number" value={prg} onChange={(e)=>{
       setprg(e.target.value)
     }} name="prg" placeholder="Enter percentage progress" required></Input>
        </FormGroup>
      <FormGroup>
     <h1>SENDER DETAILS</h1>
   
      <Label>Sender Name:</Label>
     <Input type="text" value={sender} onChange={(e)=>{
       setsender(e.target.value)
     }} name="sender" placeholder="Enter sender name" required></Input>
     
      <Label>Phone:</Label>
     <Input type="text" value={sphone} onChange={(e)=>{
       setsphone(e.target.value)
     }} name="phone" placeholder="Enter phone number" required></Input>
     <Label>Email:</Label>
     <Input type="text" value={semail} onChange={(e)=>{
       setsemail(e.target.value)
     }} name="email" placeholder="Enter email" required></Input>
     
      <Label>Origin Country:</Label>
      <Select options={options} required value={OC} onChange={changeHandler} />
     
    
     
     <Label>origin address:</Label>
     <Input type="text" value={org} onChange={(e)=>{
       setorg(e.target.value)
     }} name="org" placeholder="Enter origin address" required></Input>
    
   
    
   </FormGroup>
   <FormGroup>
   <h1>RECEIVER DETAILS</h1>
   <Label>Reciever Name:</Label>
     <Input type="text" value={receiver} onChange={(e)=>{
       setreceiver(e.target.value)
     }} name="receiver" placeholder="Enter receiver name" required></Input>
     <Label>Phone:</Label>
     <Input type="text" value={phone} onChange={(e)=>{
       setphone(e.target.value)
     }} name="phone" placeholder="Enter phone number" required></Input>
     <Label>Email:</Label>
     <Input type="text" value={email} onChange={(e)=>{
       setemail(e.target.value)
     }} name="email" placeholder="Enter email" required></Input>
     <Label>destination country:</Label>
     <Select options={options} required value={dc} onChange={changeHandler2} />
     
      <Label>destination address:</Label>
     <Input type="text" value={dst} onChange={(e)=>{
       setdst(e.target.value)
     }} name="dst" placeholder="Enter destination address" required></Input>
     
     <Label>Current Location:</Label>
     <Select required options={options} value={cl} onChange={changeHandler3} />

     
   </FormGroup>
      
      </div>
      
   <div style={{display:'flex',justifyContent:'center',margin:'auto',gap:'10px'}}><Button type="submit" >Submit</Button>
      <Link to="/admindash104" className="btn btn-danger ml-2">Cancel</Link></div>
      
    </Form>
    </div>
  )
}
